export const removeTrailingSlash = (value: string | undefined) => {
  return (value || '').replace(/\/+$/, '')
}
